// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';

// Relative Imports
import './LeadAppContainer.less';
import actions from '../../actions/actions';
import helpActions from '../../actions/help';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import MainContent from '../MainContent/MainContent';
import WebFormPage from '../WebformPage/WebFormPageContainer';
import {localizeUrl} from '@homeaway/localization-utils';
import {getPreferredLocale} from '../../utils/localStorageDataHandler';
import WebformInfoPage from '../WebformInfoPage/WebformInfoPageContainer';
import {checkLocalStateAndRedirect} from '../utils/commonUtil';
import {isHelpLinkTextAvailable} from '../utils/commonUtil';

function mapStateToProps(state) {
    return {
        appState: state.app.appState,
        enableLoadOverlay: state.app.enableLoadOverlay,
        publicUuid: state.app.publicUuid,
        authState: state.app.authState,
        translations: state.app.translations,
        brandName: state.system.brandName,
        siteName: state.system.siteName,
        logoBrandName: state.system.logoBrandName,
        footerData: state.app.footerData,
        supportedLocales: state.app.supportedLocales,
        locale: state.system.locale,
        preferredLocale: state.system.preferredLocale,
        environment: state.system.environment,
        nodeEnvironment: state.system.nodeEnvironment,
        headerData: state.app.headerData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        helpActions: bindActionCreators(helpActions, dispatch),
        actions: bindActionCreators(actions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class LeadAppContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        if (this.props.authState) {
            this.handlePreferredLocale();
        }
    }

    componentDidMount() {
        window.history.pushState(
            '',
            '',
            localizeUrl(`/p/pm-intake`, window.__SITE_CONTEXT__)
        );
    }

    handlePreferredLocale = () => {
        const {publicUuid, preferredLocale, authState} = this.props;

        if (authState) {
            const savedLocale = getPreferredLocale(publicUuid);
            if (savedLocale) {
                if(savedLocale !== preferredLocale) {
                    this.redirectToNewLocale(savedLocale);
                }
            } else if (!this.isLocaleRedirectEligible()) {
                this.props.actions.savePreferredLocale(publicUuid, preferredLocale);
            }
        }
    }

    isLocaleRedirectEligible = () => (this.props.locale === this.props.preferredLocale);

    redirectToNewLocale = (locale) => {
        if (typeof window !== 'undefined') {
            const {protocol, host, pathname, search} = window.location;
            const appUrl = `${protocol}//${host}${pathname}`;
            const localParamStr = `locale=${locale}`;
            window.location = search ? `${appUrl}${search}&${localParamStr}` : `${appUrl}?${localParamStr}`;
        }
    }


    // eslint-disable-next-line complexity
    render() {
        const {
            appState,
            authState,
            translations,
            enableLoadOverlay,
            footerData,
            headerData
        } = this.props;

        let panelContent;
        let skipHeader = false;
        let skipMainContainer = true;
        let skipFooter = true;
        let isLandingPage = false;
        let isWebFormPage = true;
        let helpLinkTexts = isHelpLinkTextAvailable(headerData) ? headerData.header.help.items : [];
        switch (appState) {
            case 'WEBFORMINFO_PAGE':
                panelContent = <WebformInfoPage/>;
                break;
            default:
                checkLocalStateAndRedirect(this.props);
                panelContent = <WebFormPage />;
                break;
        }

        return (
            <div>
                <Header
                    authState={authState}
                    translations={translations}
                    skipComponent={skipHeader}
                    triggerEdapEvent={this.props.actions.triggerEdapEvent}
                    toggleHelpModal={this.props.helpActions.toggleHelpModal}
                    siteName={this.props.siteName}
                    changeAppState={this.props.actions.changeAppState}
                    isLandingPage={isLandingPage}
                    logoBrandName={this.props.logoBrandName}
                    supportedLocales={this.props.supportedLocales}
                    preferredLocale={this.props.preferredLocale}
                    savePreferredLocale={this.props.actions.savePreferredLocale}
                    publicUuid={this.props.publicUuid}
                    isWebFormPage={isWebFormPage}
                    helpLinkTexts={helpLinkTexts}
                    environment={this.props.environment}
                    nodeEnvironment={this.props.nodeEnvironment}
                />
                <MainContent
                    panelContent={panelContent}
                    skipComponent={skipMainContainer}
                    enableLoadOverlay={enableLoadOverlay}
                />
                <Footer
                    translations={translations}
                    skipComponent={skipFooter}
                    isLandingPage={isLandingPage}
                    footerData={footerData}
                />
            </div>
        );
    }
}

LeadAppContainer.propTypes = {
    appState: PropTypes.oneOf([
        'WEBFORMINFO_PAGE'
    ]),
    authState: PropTypes.bool,
    translations: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    enableLoadOverlay: PropTypes.bool
};

export default LeadAppContainer;
